import type { FC, SVGProps } from "react";

const IconEarlyCheckInOrOut: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M11 1V9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.92969 9.93005L5.33969 11.3401" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1 17H3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 17H21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18.0702 9.93005L16.6602 11.3401" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M21 21H1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 5L11 1L15 5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15 17C15 15.9391 14.5786 14.9217 13.8284 14.1716C13.0783 13.4214 12.0609 13 11 13C9.93913 13 8.92172 13.4214 8.17157 14.1716C7.42143 14.9217 7 15.9391 7 17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconEarlyCheckInOrOut;
